import { useGetTemplatesQuery } from "../../redux/services/templates/api";
import { Select } from "../../shared";
import { useCallback } from "react";
import { useConfig } from "../../hooks";
import { templateMatchesAppType } from "../../pages/Settings/Templates/template.utils";

const TemplateSelect = ({ type, onChange, value }) => {
  const { appType } = useConfig();
  const {
    data: templateData,
    isLoading,
    isError,
  } = useGetTemplatesQuery({
    type,
  });

  const emptyData = [{ label: "No templates found", value: null }];
  const templates =
    templateData?.templates
      ?.filter((template) => !type || template.type === type)
      ?.filter((template) => templateMatchesAppType(template, appType))
      .map((template) => ({
        label: template.name,
        value: template._id,
        template,
      })) || [];

  const handleChange = useCallback(
    (selected) => {
      onChange(selected);
    },
    [onChange]
  );

  return (
    <Select
      value={value}
      loading={isLoading}
      wrapperClasses="w-3/5"
      options={templates.length === 0 ? emptyData : templates}
      size="sm"
      labelClasses="text-gray-700"
      onChange={handleChange}
      id="template"
      placeholder="Select Template"
    />
  );
};

export default TemplateSelect;
